import React, { useState } from 'react';
import { Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../common/styles/styles';
import { useUser } from '../../../userContext';

export default function ApplicationModal({ application, onApplicationUpdate }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const { ccgEmployee } = useUser();
  
  const handleOpen = () => {
    setOpen(true);
    setTitle('Edit Application');
  }

  const handleUpdate = async (event) => {
      await editApplication(event);      
      setOpen(false);
      onApplicationUpdate(application);
  }

  const handleClose = () => setOpen(false);

  const [formData, setFormData] = useState({
      id: application.id,
      collector: application.collector,
      name: application.name,
      port: application.port,
      authorized: application.authorized ? application.authorized : false,
      notes: application.notes
  });

  const handleInputChange = (field) => (event) => {    
      const value = event.target.value;
      setFormData({ ...formData, [field]: value });
  };
  
  const editApplication = async (event) => {
    try {
        event.preventDefault();
        const response = await fetch(`${process.env.REACT_APP_API}/applications/${formData.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });
        const result = await response.json();
        return result;
    } catch (error) {
      console.error('Network error.  Please try again: ', error);
    }
  }

  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ]
  
  const textFieldStyles = Styles.textFieldStyles;

  return (
    <>
        
        { ccgEmployee ?
            <Button variant="outlined" color="success" size="small" onClick={handleOpen} >
                <EditIcon />
            </Button> 
            :
            <Button variant="outlined" sx={{ border: '1px solid red', borderColor: 'red', color: 'red' }}  size="small">
                <EditIcon />
            </Button> 
        }
        
        <Modal 
          open={open} 
          onClose={handleClose}
          style={{
            overlay: {
              backgroundColor: '#080030', // Semi-transparent black
            },
            content: {
              backgroundColor: '#080030',
            },
          }}
        >
            <Box sx={{color: 'white', p: 4}}>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                  }}
                >
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                    {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                    <Stack spacing={2}>
                      <TextField
                          select 
                          required
                          fullWidth
                          label="Authorized"
                          value={formData.authorized}
                          onChange={handleInputChange('authorized')}
                          sx={ textFieldStyles }  
                        >
                          {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </TextField>
                      <TextField
                        fullWidth
                        label="Note"
                        value={formData.notes}
                        onChange={handleInputChange('notes')}
                        sx={ textFieldStyles }
                      />
                  <ButtonGroup 
                    size="small"
                    variant="contained" 
                    aria-label="Basic button group" 
                    fullWidth
                    sx={{ mt:2 }}
                  >
                    <Button
                      onClick={handleClose}
                      type="cancel"
                      variant="contained"
                      sx={ Styles.buttonStyle }
                    >
                      Cancel
                    </Button>              
                    <Button
                      type="submit"                      
                      variant="contained"
                      sx={{ ...Styles.buttonStyle,  ml:4 }}
                    >
                      {title}
                    </Button>
                  </ButtonGroup>
                </Stack>
              </Box>
            </Box>
          </Box>          
        </Modal>
    </>
  );
}